import AbstractModal from './AbstractModal';

export default class extends AbstractModal {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                dropdown: 'update',
                item: 'update'
            },
            click: Object.assign({
                apply: 'applyFilters',
                reset: 'onReset',
                clear: 'clearFilter'
            }, this.events.click)
        }

        this.$form = this.$('form')[0]
        this.$groups = Array.from(this.$('group'))
        this.groupSlugs = this.$groups.map(group => this.getData('group-slug', group))
        this.$items = Array.from(this.$('item'))
        this.$counter = this.$('count')[0]

        this.indexedItems = JSON.parse(this.getData('indexed-items'))
        this.baseUrl = this.getData('base-url');
    }

    init() {
        super.init();

        this.update();
    }

    update() {
        this.formData = new FormData(this.$form);

        this.updateRules();
        this.$counter.innerText = this.computeResults();
        this.updateParams();
        this.updateView();
    }

    updateRules() {
        this.rules = {};
        for (const [ key, value ] of this.formData.entries()) {
            if (key && value.length) { // Do not consider empty value
                if (!this.rules[key]) {
                    this.rules[key] = [];
                }

                this.rules[key].push(value);
            }
        }
    }

    /**
     * @param  {{ key: string, value: any }} [extraRule] - Add or replace a rule.
     * @return {Number}
     */
    computeResults(extraRule) {
        const rules = JSON.parse(JSON.stringify(this.rules));

        // `null` is considered an object.
        if (extraRule != null && typeof extraRule === 'object') {
            const { key, value, exclusive } = extraRule;

            if (!rules[key] || exclusive) {
                rules[key] = [];
            }

            rules[key].push(value);
        }

        // //// Compute results OR

        // const results = this.indexedItems.filter(item => {
        //     let keep = true

        //     for(const groupSlug of this.groupSlugs) {
        //         if(groupSlug == 'orderby') continue;

        //         if(rules[groupSlug] && rules[groupSlug].length) {
        //             keep = rules[groupSlug].some(r=> item[groupSlug].includes(r))
        //         }

        //         if(!keep) return keep;
        //     }

        //     return keep;
        // })

        // //// Compute results AND

        // Filter all items.
        const results = this.indexedItems.filter(item => {
            // Keep by default, we'll look for reasons not to keep.
            let keep = true

            // Loop over all filter groups.
            for (const groupSlug of this.groupSlugs) {
                // Ignore `orderby` as it shouldn't filter anything.
                if (groupSlug === 'orderby') {
                    continue;
                }

                // If the rule is defined (in other words, not empty), check if it's valid.
                if (rules[groupSlug] && rules[groupSlug].length) {
                    // `item[groupSlug]` must contain all entries of `rules[groupSlug]`.
                    keep = rules[groupSlug].every(r => item[groupSlug].includes(r));
                }

                // If we found a reason not to keep it, return false, otherwise, let it continue.
                if (!keep) {
                    return false;
                }
            }

            // Final decision.
            return keep;
        })

        return results.length;
    }

    updateView() {
        for (const $group of this.$groups) {
            const groupSlug = this.getData('group-slug', $group);
            const groupValues = this.formData.getAll(groupSlug);

            for (const item of this.$('item', $group)) {
                let name = item.name;
                let exclusive = false;

                if(item.tagName == 'OPTION') {
                    name = item.closest('select').name;
                    exclusive = true;
                }

                // Ignore active filter buttons
                if (!groupValues.includes(item.value) && item.value.length) {
                    const results = this.computeResults({
                        key:   name,
                        value: item.value,
                        exclusive // If we only want this one value to be considered for that key
                    });
                    item.disabled = (results < 1);
                }
            }
        }

        const urlParams = this.urlParams.toString();

        this.$form.classList.toggle('is-resettable', (Object.keys(this.rules).length > 1));
        this.$form.classList.toggle('is-altered', (
            urlParams
            ? window.location.search != '?' + urlParams
            : window.location.search != urlParams)
        );
    }

    updateParams() {
        this.urlParams = new URLSearchParams();

        for(let [rule, value] of Object.entries(this.rules)) {
            if(rule == 'orderby' && value == 'default') continue;
            this.urlParams.set(rule, value.join(','))
        }
    }

    onReset(e) {
        e.preventDefault();
        e.stopPropagation();

        // Reset form to default state
        this.$form.reset();
        // Force remove the `checked` attribute on checkboxes because native reset goes to default values & a `checked` attribute is considered default value
        this.$form.querySelectorAll('input[type="checkbox"][checked]').forEach(el => el.removeAttribute('checked'));
        // Force remove the `selected` attribute on options because native reset goes to default values & a `selected` attribute is considered default value
        this.$form.querySelectorAll('option[selected]').forEach(el => el.removeAttribute('selected'));
        // Upate view
        this.update();
    }

    onDeactivate() {
        // Reset form to default state
        this.$form.reset();
        // Upate view
        this.update();
    }

    applyFilters(e) {
        e.preventDefault();
        e.stopPropagation();

        if(window.location.search != '?'+this.urlParams.toString()) {
            this.call('goTo', this.baseUrl+'?'+this.urlParams.toString(), 'Load');
            this.close();
        }
    }

    clearFilter(e) {
        const target = e.curTarget;
        target.previousElementSibling.value = '';
        this.update()
    }
}
